import clsx from "clsx";

/** Tiny classNames helper (clsx). */
export function cn(...args) {
  return clsx(...args);
}
